import React from "react";

import {CircularProgress, Stack} from "@mui/joy";

// components
import NewQuoteCreateModal from "./NewQuoteCreateModal";
import BaseApi from "../../utils/BaseApi";
import CommonPaginatedComponentList from "../Common/CommonPaginatedComponentList";
import NewQuoteCard from "./NewQuoteCard";
import withRouter from "../../utils/withRouter";


class NewQuoteList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            quotes: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveQuotes();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveQuotes();
        }
    }

    async retrieveQuotes() {
        const url = 'new_quote/';
        const api = new BaseApi();
        let params = {}
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        this.setState(
            {
                quotes: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    render() {
        if (!this.state.quotes) {
            return (<CircularProgress/>)
        }
        return(
            <Stack
                spacing={2}
            >
                <NewQuoteCreateModal
                    opportunity={this.props.opportunity}
                    callBack={this.retrieveQuotes.bind(this)}
                />
                <CommonPaginatedComponentList
                    title={'ТКП'}
                    component={NewQuoteCard}
                    componentKeyword={'quote'}
                    url={'quote'}
                    componentProps={{
                        showOpportunity: true,
                        showAccount: true,
                        variant: 'soft',
                    }}
                    data={this.state.quotes}
                    callBack={this.retrieveQuotes.bind(this)}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                />
            </Stack>
        )
    }
}

export default withRouter(NewQuoteList)
